import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useMemo } from 'react';
import moment from 'moment';
import { Form } from "react-final-form";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { deleteAssessment, updateAssessment } from 'actions/assessments';
import { Expandable } from 'UI';
import { Button, Checkbox, Icon } from '@haldor/ui';
import './ClearBlockAssessments.scss';

var ClearBlockAssessments = function ClearBlockAssessments(props) {
  var translate = useTranslate();
  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedResources = _useState2[0],
      setSelectedResources = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      feedback = _useState4[0],
      setFeedback = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      notes = _useState6[0],
      setNotes = _useState6[1];

  var blocks = useSelector(function (state) {
    return state.Blocks.reference;
  });

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      totalAssessments = _useState8[0],
      setTotalAssessments = _useState8[1];

  var resources = useMemo(function () {
    if (blocks == null) {
      return [];
    }

    var assessmentBlocks = blocks.filter(function (block) {
      return block.type == "Haldor.Blocks.AssessmentBlock";
    });
    var blockParts = [];
    assessmentBlocks.forEach(function (block) {
      if (block.resources == null) {
        return false;
      }

      var title = block.title;
      var assmentsObject = {};
      block.resources.forEach(function (resource) {
        var inDetails = true;
        props.assessments.forEach(function (assessment) {
          var inItems = props.items.find(function (item) {
            return item.assignedTo == assessment.studentId;
          });

          if (inItems != null) {
            assessment.assessmentDetails.forEach(function (assessmentDetail) {
              var inResource = resource.assessmentBlockPartRows.find(function (blockPartRow) {
                return blockPartRow.id == assessmentDetail.assessmentBlockPartRowId;
              });

              if (inResource != null) {
                inDetails = true;
              }
            });
          }
        });

        if (inDetails) {
          assmentsObject = {
            id: block.id,
            title: title,
            items: [resource],
            sortOrder: block.sortorder
          };
        }

        var findItem = blockParts.find(function (i) {
          return i.id === block.id;
        });

        if (findItem && (blockParts === null || blockParts === void 0 ? void 0 : blockParts.length) > 0) {
          findItem === null || findItem === void 0 ? void 0 : findItem.items.push(resource);
          var item = blockParts.indexOf(function (x) {
            return x.id === block.id;
          });

          if (item !== -1) {
            blockParts[item].items.push(resource);
          }
        } else {
          blockParts.push(assmentsObject);
        }
      });
    });
    var count = blockParts.length; //move asessmentsGoal type to first index

    blockParts.forEach(function (element) {
      count += element.items.length;
      element.items.sort(function (a, b) {
        if (a.referenceType === 'assessmentGoal' && b.referenceType !== 'assessmentGoal') {
          return -1;
        }

        if (a.referenceType !== 'assessmentGoal' && b.referenceType == 'assessmentGoal') {
          return 1;
        }

        return 0;
      });
    });
    setTotalAssessments(count);
    blockParts.sort(function (a, b) {
      return (a === null || a === void 0 ? void 0 : a.sortOrder) - (b === null || b === void 0 ? void 0 : b.sortOrder);
    });
    return blockParts;
  }, [props.assessments, blocks]); //get child items and compare to resources to determine if all is selected

  var checkNumberOfItems = function checkNumberOfItems() {
    var parentLength = 0;
    var findChilds = []; //get child items and compare to resources to determine if all is selected

    resources.forEach(function (element) {
      var _element$items;

      var findElement = element === null || element === void 0 ? void 0 : element.items.filter(function (x) {
        return selectedResources.find(function (s) {
          return s == x.id;
        });
      });
      parentLength += element === null || element === void 0 ? void 0 : (_element$items = element.items) === null || _element$items === void 0 ? void 0 : _element$items.length;
      findChilds = [].concat(_toConsumableArray(findChilds), _toConsumableArray(findElement));
    });
    return parentLength === findChilds.length;
  };

  var findAndRemoveItem = function findAndRemoveItem(idsToFind, newAssessment, isPrivate) {
    var tempArr = [];
    resources.forEach(function (element) {
      var _element$items2;

      element === null || element === void 0 ? void 0 : (_element$items2 = element.items) === null || _element$items2 === void 0 ? void 0 : _element$items2.forEach(function (assessment) {
        var existingFeedback = assessment.assessmentBlockPartRows.filter(function (x) {
          return idsToFind.find(function (t) {
            return x.assessmentBlockPartId == t;
          });
        }).map(function (x) {
          return x === null || x === void 0 ? void 0 : x.assessmentBlockPartId;
        });

        if (existingFeedback.length > 0) {
          tempArr = [].concat(_toConsumableArray(tempArr), _toConsumableArray(existingFeedback));
        }
      });
    });

    if (tempArr.length > 0) {
      var assessmentFeedbacksBlocks = [];
      var feedbackIds = tempArr.filter(function (item, index, self) {
        return self.findIndex(function (t) {
          return t === item;
        }) === index;
      });
      newAssessment.assessmentFeedbacks.forEach(function (element) {
        feedbackIds.find(function (x) {
          if (element.assessmentBlockPartId == x) {
            assessmentFeedbacksBlocks.push(element);
          }
        });
      });
      var removeData = [];

      if (isPrivate) {
        removeData = assessmentFeedbacksBlocks.filter(function (feedbacks) {
          return feedbacks.isPrivate;
        });
      } else {
        removeData = assessmentFeedbacksBlocks.filter(function (feedbacks) {
          return !feedbacks.isPrivate;
        });
      }

      newAssessment.assessmentFeedbacks = newAssessment.assessmentFeedbacks.filter(function (feedback) {
        return !removeData.find(function (x) {
          return feedback.id == x.id;
        });
      });
    }
  };

  var onSubmit = function onSubmit() {
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        var promises;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                promises = [];
                props.items.forEach(function (item) {
                  var assessment = props.assessments.find(function (assessment) {
                    return assessment.studentId == item.assignedTo || assessment.id === item.assignedTo;
                  });

                  if (assessment == null) {
                    return false;
                  }

                  var newAssessment = JSON.parse(JSON.stringify(assessment));
                  var findObjects = resources.filter(function (x) {
                    return selectedResources.find(function (s) {
                      return s == x.id;
                    });
                  });
                  var isAllSelected = checkNumberOfItems();

                  if (findObjects.length === resources.length || isAllSelected) {
                    promises.push(dispatch(deleteAssessment(assessment.id)));
                  } else {
                    newAssessment.assessmentDetails = newAssessment.assessmentDetails.filter(function (assessmentDetail) {
                      var foundSelected = selectedResources.find(function (resourceId) {
                        var resource = null;
                        blocks.forEach(function (block) {
                          var foundResource = block.resources.find(function (resource) {
                            return resource.id == resourceId;
                          });
                          if (foundResource != null) resource = foundResource;
                        });

                        if (resource == null) {
                          return false;
                        }

                        return resource.assessmentBlockPartRows.find(function (blockPartRow) {
                          return blockPartRow.id == assessmentDetail.assessmentBlockPartRowId;
                        });
                      });
                      return foundSelected == null;
                    }); //handle feedback  in an assessment

                    if (feedback.length > 0) {
                      findAndRemoveItem(feedback, newAssessment);
                    }

                    if (notes.length > 0) {
                      findAndRemoveItem(notes, newAssessment, true);
                    }

                    newAssessment.assessmentFeedbacks = newAssessment.assessmentFeedbacks.filter(function (feedback) {
                      return feedback.text != '';
                    });
                    promises.push(dispatch(updateAssessment(newAssessment, assessment)));
                  }
                });
                Promise.all(promises).then(function () {
                  props.onAbort(true);
                  resolve(1);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  var handleNoteFeedback = function handleNoteFeedback(note, id) {
    if (note) {
      if (notes.includes(id)) {
        setNotes(notes.filter(function (m) {
          return m != id;
        }));
      } else {
        setNotes([].concat(_toConsumableArray(notes), [id]));
      }

      return;
    }

    if (feedback.includes(id)) {
      setFeedback(feedback.filter(function (m) {
        return m != id;
      }));
    } else {
      setFeedback([].concat(_toConsumableArray(feedback), [id]));
    }
  };

  var selectNoteAndFeedback = function selectNoteAndFeedback(id, remove) {
    if (remove) {
      setFeedback(feedback.filter(function (m) {
        return m != id;
      }));
      setNotes(notes.filter(function (m) {
        return m != id;
      }));
      return;
    }

    setFeedback([].concat(_toConsumableArray(feedback), [id]));
    setNotes([].concat(_toConsumableArray(notes), [id]));
  };

  var onSelectResource = function onSelectResource(resource, parent) {
    var child = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var parentId = arguments.length > 3 ? arguments[3] : undefined;

    if (selectedResources.includes(resource.id)) {
      if (parent) {
        var test = resources.find(function (x) {
          return x.id === resource.id;
        });

        var ids = _toConsumableArray(test.items.map(function (row) {
          return row.id;
        }));

        var removeFeedBack = feedback.filter(function (t) {
          return !ids.includes(t);
        });
        var removenote = notes.filter(function (t) {
          return !ids.includes(t);
        });
        setFeedback(removeFeedBack);
        setNotes(removenote);
        ids.push(resource.id);
        var removeItems = selectedResources.filter(function (t) {
          return !ids.includes(t);
        });
        setSelectedResources(removeItems);
        return;
      } // TODO should childs also be selected ?


      if (child) {
        selectNoteAndFeedback(resource.id, true);

        if (selectedResources.includes(parentId)) {
          setSelectedResources(selectedResources.filter(function (m) {
            return m != resource.id && m != parentId;
          }));
        } else {
          setSelectedResources(selectedResources.filter(function (m) {
            return m != resource.id;
          }));
        }

        return;
      }

      setSelectedResources(selectedResources.filter(function (m) {
        return m != resource.id;
      }));
    } else {
      if (parent) {
        var _test = resources.find(function (x) {
          return x.id === resource.id;
        });

        var id = _test.id;

        var _ids = _test.items.map(function (row) {
          return row.id;
        });

        if (_ids.length > 0) {
          setFeedback([].concat(_toConsumableArray(feedback), _toConsumableArray(_ids)));
          setNotes([].concat(_toConsumableArray(notes), _toConsumableArray(_ids)));
        }

        var preSelected = [].concat(_toConsumableArray(selectedResources), [id], _toConsumableArray(_ids));
        var findObjects = resources.filter(function (x) {
          return preSelected.find(function (s) {
            return s == x.id;
          });
        });
        setSelectedResources([].concat(_toConsumableArray(selectedResources), [id], _toConsumableArray(_ids)));
        return;
      } // TODO should childs also be selected ?


      if (child) {
        selectNoteAndFeedback(resource.id, false);
        var findParent = resources.find(function (x) {
          return x.id === parentId;
        });

        if (findParent) {
          var arr = findParent === null || findParent === void 0 ? void 0 : findParent.items.filter(function (x) {
            return [].concat(_toConsumableArray(selectedResources), [resource.id]).find(function (s) {
              return s == x.id;
            });
          });

          if (arr.length === (findParent === null || findParent === void 0 ? void 0 : findParent.items.length)) {
            setSelectedResources([].concat(_toConsumableArray(selectedResources), [resource.id, parentId]));
            return;
          }
        }

        setSelectedResources([].concat(_toConsumableArray(selectedResources), [resource.id]));
        return;
      }

      setSelectedResources([].concat(_toConsumableArray(selectedResources), [resource.id]));
    }
  };

  var toggleAll = function toggleAll(checked) {
    if (checked) {
      setSelectedResources(resources.map(function (row) {
        return row.id;
      }));
      var id = resources.map(function (row) {
        return row.id;
      });
      var data = [];
      var feed_notes = [];
      id.forEach(function (elementId) {
        var test = resources.find(function (x) {
          return x.id === elementId;
        });
        var ids = [elementId].concat(_toConsumableArray(test === null || test === void 0 ? void 0 : test.items.map(function (row) {
          return row.id;
        })));

        if (ids.length > 0) {
          ids.forEach(function (element) {
            feed_notes = [].concat(_toConsumableArray(feed_notes), [element]);
          });
        }

        data = [].concat(_toConsumableArray(data), _toConsumableArray(ids));
      });
      setNotes(feed_notes);
      setFeedback(feed_notes);
      setSelectedResources(data);
    } else {
      setSelectedResources([]);
      setNotes([]);
      setFeedback([]);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form-container form"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
          form = _ref2.form,
          valid = _ref2.valid,
          submitting = _ref2.submitting,
          initialValues = _ref2.initialValues;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "form form-component"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement(Expandable, {
        title: translate('Students')
      }, /*#__PURE__*/React.createElement("div", null, props.items.map(function (item) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.id,
          style: {
            marginBottom: '.45rem'
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          disabled: true,
          value: true,
          label: item.groupName
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('Select the assessments to be deleted')), /*#__PURE__*/React.createElement(Checkbox, {
        label: translate('Select all'),
        onChange: toggleAll,
        value: totalAssessments == selectedResources.length
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: '2.5rem'
        }
      }, resources != null && resources.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '.45rem',
          marginBottom: '1rem'
        }
      }, resources.map(function (resource) {
        var _resource$items;

        var title = resource.title;
        /* 	let title = translate('Goal'); */

        if (resource.referenceType == 'matrix') {
          title = "".concat(resource.value.title, " (").concat(resource.value.courseCode, ")");
        }

        var detail = null;

        if (detail != null) {
          if (detail.endDate != null && moment(detail.endDate).isBefore(moment())) {
            title = /*#__PURE__*/React.createElement("span", null, title, /*#__PURE__*/React.createElement("span", {
              style: {
                position: 'relative',
                top: 2,
                margin: '0 .25rem'
              }
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Alert_Red"
            })), translate('Expired'));
          }
        }

        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '.75rem'
          },
          key: resource.id
        }, /*#__PURE__*/React.createElement("ul", {
          className: "remove-assesments-list"
        }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Checkbox, {
          label: title,
          value: selectedResources.includes(resource.id),
          onChange: function onChange() {
            return onSelectResource(resource, true, false, resource.id);
          }
        })), /*#__PURE__*/React.createElement("li", null, ((_resource$items = resource.items) === null || _resource$items === void 0 ? void 0 : _resource$items.length) > 0 ? /*#__PURE__*/React.createElement("ul", null, resource.items.map(function (assessment, index) {
          var _assessment$value;

          return (// Do not list clarifications that are returned from migrated assignments and plans
            (assessment === null || assessment === void 0 ? void 0 : assessment.referenceType) === 'matrix' || (assessment === null || assessment === void 0 ? void 0 : assessment.referenceType) === 'assessmentGoal' ? /*#__PURE__*/React.createElement("li", {
              key: index
            }, /*#__PURE__*/React.createElement(Checkbox, {
              label: (assessment === null || assessment === void 0 ? void 0 : assessment.referenceType) === 'matrix' ? assessment === null || assessment === void 0 ? void 0 : (_assessment$value = assessment.value) === null || _assessment$value === void 0 ? void 0 : _assessment$value.title : translate('Goal'),
              value: selectedResources.includes(assessment.id),
              onChange: function onChange() {
                return onSelectResource(assessment, false, true, resource.id);
              }
            }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Checkbox, {
              label: translate('feedback'),
              value: feedback.includes(assessment.id),
              onChange: function onChange() {
                return handleNoteFeedback(false, assessment.id);
              }
            })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Checkbox, {
              label: translate('Personal note'),
              value: notes.includes(assessment.id),
              onChange: function onChange() {
                return handleNoteFeedback(true, assessment.id);
              }
            })))) : null
          );
        })) : null)));
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid
      }, translate("Remove assessments")), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();
          props.onAbort(false);
        }
      }, translate("Cancel")))));
    }
  }));
};

export default ClearBlockAssessments;